// swr.js

(function (window, document, $, undefined) {
  var Planet = {};

  function expose() {
    var oldPlanet = window.Planet;

    Planet.noConflict = function () {
      window.Planet = oldPlanet;
      return this;
    };

    window.Planet = Planet;
  }

  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = Planet;
  } else if (typeof define === 'function' && define.amd) {
    define(Planet);
  }

  if (typeof window !== 'undefined') {
    expose();
  }

}(window, document, window.jQuery));
